import { Box, Typography } from '@mui/material';
import { HeatmapLegend } from './HeatmapLegend';
import { Feature, FeatureCollection, MultiPolygon, Polygon } from 'geojson';
import React from 'react';
import appTheme from '../theme/appTheme.json';
import { darkThemeBeamRGBValues } from '../../../shared/entities/beam';

export interface HeatmapLegendPanelProps {
  data: FeatureCollection<MultiPolygon, Polygon>;
  linkType: 'rl' | 'fl';
  numberOfBands: number;
  leftOffset: boolean;
}

const HeatmapLegendPanel = (props: HeatmapLegendPanelProps) => {
  const { data, linkType, numberOfBands, leftOffset } = props;

  return (
    <Box
      position="absolute"
      padding="12px"
      left={leftOffset ? '372px' : '14px'}
      top="62px"
      bgcolor={`${appTheme.primaryBackgroundColor}cc`}
    >
      <Box color={appTheme.primaryTextColor}>
        <Typography>Data Rate Key</Typography>
      </Box>
      {(data.features || []).find(
        (feature: Feature<Polygon | MultiPolygon>) =>
          (feature.properties || {}).rlDataRateBps || (feature.properties || {}).flDataRateBps,
      ) ? (
        <Box>
          <HeatmapLegend
            type="boxes"
            featureCollection={data as FeatureCollection<MultiPolygon, Polygon>}
            baseColor={darkThemeBeamRGBValues.ku}
            linkType={linkType}
            boxLimit={numberOfBands}
            boxBorderColor="#465967"
            labelTextColor="#ffffffcc"
            sortDirection="ascending"
            enableBlend={true}
            blendOpacity={0.382}
            blendColor="#3e4f60"
          />
        </Box>
      ) : (
        <Box color={appTheme.disabledTextColor}>
          <Typography>No Data</Typography>
        </Box>
      )}
    </Box>
  );
};
export default HeatmapLegendPanel;
